<template>
  <div>
    <v-dialog
      v-model="trade_review_data.flag"
      width="800"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      :hide-overlay="hideOverlay"
    >
      <v-overlay absolute v-if="loading" class="text-center">
        <v-progress-circular indeterminate color="#2d8cff" class="mr-2 my-2" />
      </v-overlay>
      <trade-form
        :trade_form_data="trade_form_data"
        v-if="trade_form_data.flag"
      />
      <v-card
        v-if="!loading"
        class="card rounded-md-lg"
        height="600"
        width="800"
      >
        <v-card-title class="title" :class="tradeFormColor">
          Review & Post Trade
          <v-spacer></v-spacer>
          <v-icon text @click="closeForm()" color="#fff" large style="cursor"
            >mdi-close
          </v-icon>
        </v-card-title>
        <div class="py-5 px-md-5">
          <TradeUserData
            :trade_data="trade_review_data.trade_data"
            :showDivider="false"
          />
          <review-and-post-trade-visibility
            v-if="$featureFlags.groups"
            v-model="visibility"
          ></review-and-post-trade-visibility>
          <div class="d-flex px-2 mt-4">
            <v-spacer></v-spacer>
            <v-btn
              class="mr-3 button"
              :color="titleBtnColor"
              x-large
              outlined
              height="40"
              @click="tradeEdit"
              >Edit
            </v-btn>
            <v-btn
              class="mr-3 button"
              :color="titleBtnColor"
              x-large
              outlined
              :loading="postBtnLoader"
              height="40"
              @click="postTrade('post')"
              >Post
            </v-btn>
            <v-btn
              height="40"
              class="button"
              :loading="postBtnLoader"
              :color="titleBtnColor"
              x-large
              @click="postandShare('share')"
            >
              Post & Share
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import Axios from "@/api/BaseAxios.js";
import TradeUserData from "./TradeUserData.vue";
import TradeForm from "./TradeForm.vue";
import ReviewAndPostTradeVisibility from "./ReviewAndPostTradeVisibility.vue";

export default {
  props: ["trade_review_data"],
  data: () => ({
    trade_data: {},
    trade_form_data: {
      flag: false,
      trade_edit: true,
      trade_data: {},
    },
    postBtnLoader: false,
    hideOverlay: false,
    loading: false,
    visibility: {
      postTo: "followers",
      groupId: null,
    },
  }),
  components: {
    "trade-form": TradeForm,
    TradeUserData,
    ReviewAndPostTradeVisibility,
  },
  methods: {
    ...mapActions("snackBar", ["showSnack"]),
    getTradeDetail() {
      const successHandler = (res) => {
        this.trade_data = res.data;
        console.log(res.data, this.trade_data, "trade data");
      };
      const errorHandler = (err) => {
        console.log(err);
      };
      Axios.request_GET(
        `api/trade/get-trade/${this.trade_review_data.trade}`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    closeForm() {
      this.trade_review_data.flag = false;
      this.trade_review_data.trade_data = {};
      this.postBtnLoader = false;
    },
    tradeEdit() {
      this.postBtnLoader = true;
      this.$emit("trade-edit", this.trade_review_data.trade_data);

      this.closeForm();
    },
    postandShare(item) {
      this.postBtnLoader = true;
      this.postTrade(item);
    },
    getLivePrice() {
      this.loading = true;
      const successHandler = (res) => {
        console.log(res);
        this.trade_review_data.trade_data.live_price =
          res.data.live_price.toFixed(2);
        this.trade_review_data.trade_data.status = "Inactive";
        const profit_percent =
          ((res.data.live_price - res.data.close_price) / res.data.live_price) *
          100;
        this.trade_review_data.trade_data.profit_percent =
          profit_percent.toFixed(2);
        const price_up_down = res.data.live_price - res.data.close_price;
        this.trade_review_data.trade_data.price_up_down =
          price_up_down.toFixed(2);
        if (this.trade_review_data.trade_data.trade_type === "Buy") {
          this.trade_review_data.trade_data.pl_data = (
            ((this.trade_review_data.trade_data.target_price -
              this.trade_review_data.trade_data.entry_price) /
              this.trade_review_data.trade_data.entry_price) *
            100
          ).toFixed(2);
        } else {
          this.trade_review_data.trade_data.pl_data = (
            ((this.trade_review_data.trade_data.entry_price -
              this.trade_review_data.trade_data.target_price) /
              this.trade_review_data.trade_data.entry_price) *
            100
          ).toFixed(2);
        }
        setTimeout(() => {
          this.loading = false;
        }, 500);
      };
      const errorHandler = (err) => {
        console.log(err);
      };
      const data = {
        id: this.trade_review_data.trade_data.security.id,
      };
      Axios.request_POST(
        `api/trade/update-live-price/`,
        data,
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },

    postTrade(item) {
      if (this.visibility.postTo === "group" && !this.visibility.groupId) {
        this.showSnack({
          text: "Please select a group",
          color: "error",
          timeout: 4500,
        });
        this.postBtnLoader = false;
        return;
      }

      this.postBtnLoader = true;
      const user_id = localStorage.getItem("profile_id");
      const data = {
        entry_price: this.trade_review_data.trade_data.entry_price,
        stop_loss: this.trade_review_data.trade_data.stop_loss,
        target_price: this.trade_review_data.trade_data.target_price,
        duration: this.trade_review_data.trade_data.duration,
        security: this.trade_review_data.trade_data.security.id,
        trade_type: this.trade_review_data.trade_data.trade_type,
        reasonings: this.trade_review_data.trade_data.reasonings,
        posted_by: user_id,
        target_stop_loss_list:
          this.trade_review_data.trade_data.target_stop_loss_list,
        first_stop_loss: this.trade_review_data.trade_data.first_stop_loss,
        final_target: this.trade_review_data.trade_data.final_target,
      };

      console.log("target_stop_loss_list", data);

      const successHandler = (res) => {
        this.showSnack({
          text: "Trade Posted Succesfully",
          color: "success",
          timeout: 4500,
        });
        if (item === "post") {
          this.$emit("reloadTrades");
        } else if (item === "share") {
          this.$emit("share-trade", res.data);
        }
        this.postBtnLoader = false;

        this.trade_review_data.flag = false;
      };

      const errorHandler = (err) => {
        this.showSnack({
          text: `${err.data.message}`,
          color: "error",
          timeout: 4500,
        });
        this.postBtnLoader = false;
      };

      let url = "api/trade/create-trade/";
      if (this.visibility.postTo === "group")
        url = `api/own-groups/${this.visibility.groupId}/post-trade/`;

      Axios.request_POST(
        url,
        data,
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
  },

  mounted() {
    this.getLivePrice();
    this.hideOverlay = false;
  },

  computed: {
    tradeFormColor() {
      if (this.trade_review_data.trade_data.trade_type == "Buy") {
        return "title--buy";
      } else {
        return "title--sell";
      }
    },

    titleBtnColor() {
      if (this.trade_review_data.trade_data.trade_type == "Buy") {
        return "#2d8cff";
      } else {
        return "#eb5757";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.text__field {
  box-sizing: border-box;
  border-radius: 5px;
  margin: 10px;
  margin-bottom: -20px;
  box-sizing: border-box;
  border-radius: 4px;
}
.button {
  text-transform: capitalize;
  color: white;
  letter-spacing: 0px;
  font-weight: 500;
  font-size: 14.7368px;
}

.title {
  color: #fff;
}

.title--sell {
  background-color: #eb5757;
}

.title--buy {
  background-color: #2d8cff;
}

.card {
  background: linear-gradient(
      0deg,
      rgba(45, 140, 255, 0.06),
      rgba(45, 140, 255, 0.06)
    ),
    #ffffff;
}
</style>
